export default __webpack_public_path__ + "static/media/GIQ Colored Logo.0b116010.png";